import { render, staticRenderFns } from "./MailToReadList.vue?vue&type=template&id=bef0bb80&"
import script from "./MailToReadList.vue?vue&type=script&lang=js&"
export * from "./MailToReadList.vue?vue&type=script&lang=js&"
import style0 from "./MailToReadList.vue?vue&type=style&index=0&id=bef0bb80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports